// export this package's api
'use strict';

module.exports = require('./Animate');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-dialog/~/rc-animate/lib/index.js
 ** module id = 328
 ** module chunks = 0
 **/